import { RefObject } from "react";

export const scrollToRef = (ref: RefObject<HTMLDivElement>) => {
  const config: ScrollIntoViewOptions = {
    behavior: "smooth",
    inline: "center",
    block: "center",
  };

  ref.current?.scrollIntoView(config);
};
